import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '../app.reducers';

export const canActivateOdd: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(fromAppRoot.selectCustomer).pipe(
    filter((customer) => customer && customer.email.length > 0),
    take(1),
    map((customer) => {
      if (customer.saxo_data_renewal_expires_at !== null) {
        store.dispatch(AppRootActions.toggleOddPageActive({ oddPageActive: true }));
        return true;
      }
      return router.parseUrl('/');
    })
  );
};

export const canActivateOddStep: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  return state.url.includes('personal-details') || router.parseUrl('/odd');
};
